import {
    emptyByDefault,
    PostPurchaseProductType,
    PostPurchaseInsuranceType,
} from '@optimaxdev/analytics/mobile';
import {pathOr} from 'ramda';

import {convertPriceEEC} from 'libs/convertPrice/convertPrice';
import {ProductType, InsuranceType} from 'pages/postPurchaseInsurance/store/order/types';

/**
 * Prepare a list of products for the structure of e-commerce events
 * @param {Array<Product>} products - Products with original structure
 * @param {number} period - Order coverage period
 * @returns {Array<PostPurchaseProductType>} prepared product list
 */
export const prepareProductDataForPostPurchase = (
    products: ProductType[],
    period = 0,
): PostPurchaseProductType[] =>
    products.map(({brand, id, name, qty, price, selected}: ProductType) => ({
        brand: pathOr('', ['label'], brand),
        id: String(emptyByDefault(id)),
        name: emptyByDefault(name),
        quantity: qty || 1,
        price: convertPriceEEC(price),
        dimension24: selected ? period : 0,
    }));

/**
 * Prepare a list of products for the structure of e-commerce events
 * @param {Array<InsuranceType>} insurances - Insurance item with original structure
 * @param {number} productsCount - selected products count
 * @param {number} grandTotal - chosen insurances price
 * @returns {Array<PostPurchaseProductType>} prepared product list
 */
export const prepareInsuranceDataForPostPurchase = (
    insurances: InsuranceType[],
    productsCount?: number,
    grandTotal?: number,
): PostPurchaseInsuranceType[] =>
    insurances.map(({insuranceId, period = 0}: InsuranceType) => ({
        brand: '',
        id: String(emptyByDefault(insuranceId)),
        name: 'insurance',
        quantity: productsCount || 1,
        dimension24: period,
        dimension60: 'upgrade',
        price: convertPriceEEC(grandTotal),
    }));
